const constantsAPI = {
  // Dev
  BASE_URL: 'https://26wu3rrns1.execute-api.ap-southeast-1.amazonaws.com/',
  // Production
  // BASE_URL: 'https://baseURL.com',
  ENV: 'dev',
  PREVIEW_VENDOR_DOCUMENT: '/vendors/master-data-request/validate'
}

export default constantsAPI